import { maxLengthMessage, requiredMessage } from "../validationMessages";

import { trimmedString } from "./trimmedString";

const MAX_LENGTH = 7;

export const streetHouseNumberValidatorRequired = trimmedString
  .max(MAX_LENGTH, maxLengthMessage(MAX_LENGTH))
  .required(requiredMessage);
export const streetHouseNumberValidator = trimmedString.max(
  MAX_LENGTH,
  maxLengthMessage(MAX_LENGTH)
);
